import React, {Component} from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import './App.css';
import 'typeface-roboto';
import {Routes} from './App.Routes';
import {AuthProvider} from './auth/AuthProvider';
import {ThemeProvider} from '@material-ui/core';
import {ReactsTheme} from "./layout/_constants";
import authService from "./auth/services/auth-service";
import {withAuthorizationInterceptor} from "./auth/interceptors/authorization-interceptor";

class App extends Component {
    render() {
    return (
         <AuthProvider authService={authService}>
            <ThemeProvider theme={ReactsTheme}>
                <Router  children={Routes} basename={"/"} />
            </ThemeProvider>
        </AuthProvider>
    );
  }
}


withAuthorizationInterceptor(authService);

export default App;
